<template>
    <SidebarMenu></SidebarMenu>
</template>

<script>
import { defineComponent } from 'vue';
import SidebarMenu from "@/Goya/components/Sidebar/SidebarMenu.vue";

const CART = 'basketMenu';
const BASKET_ITEMS = '.basketItems';

export default defineComponent({
    name: 'GeneralSidebar',
    components: {SidebarMenu},
    data() {
        return {
            eventHandlers: [],
            basketMenu: null,
        };
    },
    mounted() {

        this.basketMenu = document.getElementById(CART);
        if( this.basketMenu ) {
            this.initCartBtn();
        }

        this.trackUtmLabels();

        this.renderVideo();

        document.addEventListener('click', this.copyEmail);
    },
    unmounted() {
        window.removeEventListener('DOMContentRemoved', this.removeEventHandlers);
        this.removeEventHandlers();

        document.removeEventListener('click', this.copyEmail);
    },
    methods: {
        toClipboard( str, message ) {
            // Копируем в буфер обмена
            navigator.clipboard.writeText( str ).then(() => {
                this.$alert.success( message ); // Показываем уведомление
            }).catch((err) => {
                console.error('Copy error:', err);
            });
        },
        copyEmail( e ) {
            if( e.target.matches('a[href^="mailto:"]') ) {
                try {
                    e.preventDefault();
                    // Получаем email из href (убираем префикс mailto:)
                    const href = e.target.href;
                    const email = href.replace(/^mailto:/i, '');

                    // Копируем и показываем уведомление
                    const notificationMsg = `Email ${email} copied to clipboard!`;
                    this.toClipboard(email, notificationMsg);
                } catch (err) {
                    console.error('Mailto error:', err);
                }
            }
        },
        initCartBtn() {
            if( typeof localStorage === 'undefined' ) return;

            document.addEventListener('addToCart', (e) => {
                const num = e.detail.total_numbers || 0;
                localStorage.setItem(CART, num);
                this.setTotalNumbers(num);
            });

            const totalNumbers = localStorage.getItem(CART);
            if( totalNumbers )
                this.setTotalNumbers(totalNumbers);
        },

        trackUtmLabels() {
            const urlParams = new URLSearchParams(window.location.search);
            const source = urlParams.get('utm_source');

            if( source && source.trim() !== '' ) {
                const utmData = {
                    source:      source,
                    medium:      urlParams.get('utm_medium') || 'cpc',
                    campaign:    urlParams.get('utm_campaign') || 'none',
                    content:     urlParams.get('utm_content') || '',
                    term:        urlParams.get('utm_term') || '',
                    captured_at: Date.now()
                };

                localStorage.setItem('utm_tracker', JSON.stringify(utmData));
            }
        },

        setTotalNumbers(num) {
            const item = this.basketMenu.querySelector(BASKET_ITEMS);

            if (item) {
                if (num > 0) {
                    item.textContent = num;
                } else {
                    item.remove();
                }
            } else if (num > 0) {
                const newItem = document.createElement('span');
                newItem.classList.add('basketItems');
                newItem.textContent = num;
                this.basketMenu.appendChild(newItem);
            }
        },

        /**
         * Работа с video внутри card.
         * Добавляем видео в контейнер
         * @param element
         * @returns {HTMLVideoElement|null}
         */
        addVideo(element) {
            const thumbnail = element.querySelector('.thumbnail, .product-card__thumbnail');

            if (thumbnail && !thumbnail.querySelector('video')) {
                const video = document.createElement('video');
                video.setAttribute('autoplay', '');
                video.setAttribute('width', '100%');
                video.setAttribute('height', '100%');
                video.setAttribute('loop', '');
                video.setAttribute('playsinline', '');
                video.muted = true;

                const source = document.createElement('source');
                source.setAttribute('src', element.dataset.video);
                source.setAttribute('type', 'video/mp4');
                video.appendChild(source);

                thumbnail.appendChild(video);
                return video;
            }
            return null;
        },

        /**
         * Обработчик события наведения на блок и воспроизведение видео
         * @param element
         */
        handleHover(element) {
            const video = element.querySelector('video');
            if (video) {
                video.currentTime = 0;
                video.play().catch(error => {
                    console.error('Video play error:', error);
                });
            }
            element.classList.add('play_video');
        },

        removeEventHandlers() {
            this.eventHandlers.forEach(handler => {
                handler.element.removeEventListener('mouseenter', handler.mouseEnter);
                handler.element.removeEventListener('mouseleave', handler.mouseLeave);
            });
            this.eventHandlers = [];
        },

        renderVideo() {
            // все элементы с атрибутом data-video
            const elements = document.querySelectorAll('[data-video]');

            // фильтруем элементы, оставляя только те, у которых значение не пустое
            const items = Array.from(elements).filter(
                element => element.dataset.video && element.dataset.video.trim() !== ''
            );

            // проходим по каждому элементу
            items.forEach(element => {
                const video = this.addVideo(element);
                if (video) {
                    const mouseEnterHandler = () => this.handleHover(element);
                    const mouseLeaveHandler = () => {
                        element.classList.remove('play_video');
                        const video = element.querySelector('video');
                        if (video) video.pause();
                    };

                    element.addEventListener('mouseenter', mouseEnterHandler);
                    element.addEventListener('mouseleave', mouseLeaveHandler);

                    this.eventHandlers.push({
                        element,
                        mouseEnter: mouseEnterHandler,
                        mouseLeave: mouseLeaveHandler,
                    });
                }
            });
        },
    },
});
</script>
